<template>
    <c-input-element :label="label" :helptext="helptext" class="c-form-element--password" :name="name">
        <input v-bind="$attrs" :type="type" v-model="value" pattern="password" />
        <span class="c-form-element__password-toggle" :class="open ? 'icon-view-off' : 'icon-view'" @click.prevent="open = !open"></span>
    </c-input-element>
</template>

<script>
import Input from '@mixins/Input';

export default {
    name: 'form-password-input',
    inheritAttrs: false,
    mixins: [Input],
    data() {
        return {
            open: false
        }
    },
    computed: {
        type() {
            return this.open ? 'text' : 'password';
        }
    }
}
</script>